'use client';
import { useState, useRef, useEffect } from 'react';
import { CENTER_MODAL_OVERFLOW_HEIGHT } from '../constants/modal.mjs';

function useCenterModalContentScrollable() {
  const [scrollable, setScrollable] = useState(true);
  const $modal = useRef(null);
  useEffect(() => {
    if ($modal.current && $modal.current.offsetHeight > CENTER_MODAL_OVERFLOW_HEIGHT) {
      setScrollable(true);
    }
  }, []);
  return {
    $modal,
    scrollable
  };
}

export { useCenterModalContentScrollable as default };
